var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4 6.2c0-3-2.4-5.4-5.4-5.4h-8c-1.4 0-2.8.6-3.8 1.6l-12 11.4C0 16 0 19.4 2.2 21.6l8.2 8.2c1 1 2.4 1.6 3.8 1.6s2.8-.6 3.8-1.6l11.6-11.6c1-1 1.6-2.4 1.6-4 .2-.1.2-8.1.2-8M27 15.1 15.4 26.8c-.6.6-1.6.6-2 0l-8.4-8c-.6-.6-.6-1.6 0-2.2L16.6 4.9c.2-.2.6-.4 1-.4h8c.8 0 1.4.6 1.4 1.4v8c.4.6.2 1 0 1.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 9.9,
    r: 2
  })));
};
export default SvgTag;